<div fxLayout="row wrap">

  <div fxFlex class="form-fields" *ngFor="let value of arrayValues; let i = index; let isLast = last">

    <mat-form-field class="form-field" appearance="outline" floatLabel="always">
      <mat-label>{{label}} {{i + 1 | number:'2.0-0'}}</mat-label>
      <input type="number" matInput placeholder="..." [value]="arrayValues[i + 1] ? arrayValues[i + 1] : ''" (change)="change(i, $event.target.value)"
        (keyup)="onKeyUp($event)" [disabled]="!isLast">
      <span matPrefix class="prefix">{{i > 0 ? value + 1 : value}}&nbsp;&nbsp;-&nbsp;&nbsp;</span>
    </mat-form-field>
    <mat-error *ngIf="isLast && error" i18n>Must be greater than {{arrayValues[i]}}</mat-error>
  </div>

</div>
